import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="readablestreamdefaultreader" id="readablestreamdefaultreader"></a>
    <h1 {...{
      "id": "windowreadablestreamdefaultreader"
    }}>{`window.ReadableStreamDefaultReader`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ReadableStreamDefaultReader"
      }}>{`Web APIs - ReadableStreamDefaultReader`}</a>{`  `}</p>
    <a name="new-readablestreamdefaultreader-new" id="new-readablestreamdefaultreader-new"></a>
    <h2 {...{
      "id": "readablestreamdefaultreaderstream"
    }}>{`ReadableStreamDefaultReader(stream)`}</h2>
    <p>{`Create a new ReadableStreamDefaultReader object and locks the stream to the new reader.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStreamDefaultReader`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the supplied stream parameter is not a ReadableStream,
or it is already locked for reading by another reader.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`stream`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReadableStream`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="readablestreamdefaultreader-closed" id="readablestreamdefaultreader-closed"></a>
    <h2 {...{
      "id": "closed-"
    }}>{`closed ⇒`}</h2>
    <p>{`Returns a promise that will be fulfilled when the stream becomes closed,
or rejected if the stream ever errors or the reader’s lock is released before the stream finishes closing.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{`  `}</p>
    <a name="readablestreamdefaultreader-cancel" id="readablestreamdefaultreader-cancel"></a>
    <h2 {...{
      "id": "cancelreason"
    }}>{`cancel(reason)`}</h2>
    <p>{`Cancels the stream, signaling a loss of interest in the stream by a consumer.
The supplied reason argument will be given to the underlying source’s cancel() method.
The returned promise will fulfill if the stream shuts down successfully,
or reject if the underlying source signaled that there was an error doing so.
It will reject with a TypeError (without attempting to cancel the stream) if the stream is currently locked.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source is not a ReadableStreamDefaultReader.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="readablestreamdefaultreader-read" id="readablestreamdefaultreader-read"></a>
    <h2 {...{
      "id": "read"
    }}>{`read()`}</h2>
    <p>{`Returns a promise that allows access to the next chunk from the stream’s internal queue, if available.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Object>`}</inlineCode>{` - `}<br></br>{` `}{`If a chunk is available, the promise will be fulfilled with an object of the form
{ value: theChunk, done: false }.`}</p>
    <pre><code parentName="pre" {...{}}>{` <br></br>&emsp;If the stream becomes closed, the promise will be fulfilled with an object of the form
     { value: undefined, done: true }.
 <br></br>&emsp;If the stream becomes errored, the promise will be rejected with the relevant error.  
`}</code></pre>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source is not a ReadableStreamDefaultReader or if the source is not readable.`}</li>
    </ul>
    <a name="readablestreamdefaultreader-releaselock" id="readablestreamdefaultreader-releaselock"></a>
    <h2 {...{
      "id": "releaselock"
    }}>{`releaseLock()`}</h2>
    <p>{`Releases the reader’s lock on the corresponding stream.
After the lock is released, the reader is no longer active.
If the associated stream is errored when the lock is released,
the reader will appear errored in the same way from now on; otherwise, the reader will appear closed.
If the reader’s lock is released while it still has pending read requests,
then the promises returned by the reader’s read() method are immediately rejected with a TypeError.
Any unread chunks remain in the stream’s internal queue and can be read later by acquiring a new reader.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source is not a ReadableStreamDefaultReader.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      